import xhr from "../utils/fetch"

const get = async (userId: string) => {
  return await xhr({
    url: `/${userId}/notifications`,
    method: "GET"
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const markAsRead = async (id: string) => {
  return await xhr({
    url: `/notifications/${id}`,
    method: "PUT",
    body: { read: true }
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const remove = async (id: string) => {
  return await xhr({
    url: `/notifications/${id}`,
    method: "DELETE"
  }).then(res => res.data)
    .catch(err => { throw err })
}
const Bookdemo = async(data:any)=>{
   return await xhr({
    url:"/trail",
    method:"POST",
    body:data
   }).then(res => res.data)
    .catch(err => { throw err })
}
export const notificationsApi = {
  get,
  markAsRead,
  remove,
  Bookdemo
}